import { Stack } from '@mui/material';

import { OfferPresentationType } from '@ocx/graphql';
import { Offer } from '@ocx/data-offers';
import { OfferCard } from '@ocx/ui-offers';
import { OfferCardController } from '@ocx/feat-offers';

export type HomeFeaturedOffersControllerProps = {
  offers: Offer[];
};

export const HomeFeaturedOffersController = ({ offers }: HomeFeaturedOffersControllerProps) => {
  if (!offers.length) {
    return null;
  }

  return (
    <Stack spacing={1}>
      {offers.map((offer) => (
        <OfferCardController key={offer.id} offer={offer}>
          {(props) => (
            <OfferCard
              variant={offer.presentationType === OfferPresentationType.Banner ? 'banner' : 'featured'}
              {...props}
            />
          )}
        </OfferCardController>
      ))}
    </Stack>
  );
};
